// SPDX-License-Identifier: AGPL-3.0-or-later

import {Endpoints} from '@app/features/app/constants/Endpoints';
import Guilds from '@app/features/guild/state/Guilds';
import {http} from '@app/features/platform/transport/RestTransport';
import {Logger} from '@app/features/platform/utils/AppLogger';
import type {GuildBoostStatusResponse} from '@fluxer/schema/src/domains/guild/GuildBoostSchemas';

const logger = new Logger('GuildBoostCommands');

export function syncGuildBoostStatusToStore(guildId: string, status: GuildBoostStatusResponse): void {
	const existing = Guilds.getGuild(guildId);
	if (!existing) return;
	Guilds.handleGuildUpdate({
		...existing.toJSON(),
		premium_tier: status.premium_tier,
		premium_subscription_count: status.premium_subscription_count,
	});
}

export async function fetchGuildBoostStatus(guildId: string): Promise<GuildBoostStatusResponse> {
	try {
		const response = await http.get<GuildBoostStatusResponse>(Endpoints.GUILD_BOOSTS(guildId));
		logger.debug(`Fetched guild boost status for guild ${guildId}`);
		return response.body;
	} catch (error) {
		logger.error(`Failed to fetch guild boost status for guild ${guildId}:`, error);
		throw error;
	}
}

export async function applyGuildBoost(guildId: string): Promise<GuildBoostStatusResponse> {
	try {
		const response = await http.post<GuildBoostStatusResponse>(Endpoints.GUILD_BOOSTS(guildId), {body: {}});
		const status = response.body;
		syncGuildBoostStatusToStore(guildId, status);
		logger.debug(`Applied guild boost for guild ${guildId}`);
		return status;
	} catch (error) {
		logger.error(`Failed to apply guild boost for guild ${guildId}:`, error);
		throw error;
	}
}
